import { Chip } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import DescriptionIcon from '@mui/icons-material/Description';
import { ISubmissionPublicationPagedResponse } from '../../../../model/sep/submission-publications/response/submission-publication-paged-response';
import { dataGridDefaults } from '../../../../components/list-grid-panel';
import { RowAction } from '../../../../components/row-action';
import { TwoLineCell } from '../../../../components/two-line-cell';
import { formatDate, formatDateTime } from '../../../../utils/date';
import { SUBMISSION_STATUS_COLOR } from './submission-publication-status';

export interface ISubmissionPublicationDataTableProps {
    rows: ISubmissionPublicationPagedResponse[];
    rowCount: number;
    loading: boolean;
    page: number;
    pageSize: number;
    onPaginationChange: (page: number, pageSize: number) => void;
    onDetail: (row: ISubmissionPublicationPagedResponse) => void;
}

export default function SubmissionPublicationDataTable(props: ISubmissionPublicationDataTableProps) {
    const columns: GridColDef<ISubmissionPublicationPagedResponse>[] = [
        { field: 'id', headerName: 'Nº', width: 90 },
        {
            field: 'title', headerName: 'Remessa', flex: 1, minWidth: 240, sortable: false,
            renderCell: (params) => <TwoLineCell primary={`Nº ${params.row.id} - ${params.row.title ?? ''}`} secondary={params.row.clientName} bold />
        },
        {
            field: 'sendDate', headerName: 'Enviada em', width: 190, sortable: false,
            renderCell: (params) => <TwoLineCell primary={formatDateTime(params.row.sendDate)} secondary={params.row.userSenderName} />
        },
        {
            field: 'publishDate', headerName: 'Publicar em', width: 120, sortable: false,
            valueFormatter: (params) => formatDate(params.value as string)
        },
        {
            field: 'status', headerName: 'Status', width: 150, sortable: false,
            renderCell: (params) => <Chip size="small" label={params.row.status} color={SUBMISSION_STATUS_COLOR[params.row.statusId ?? 0] || 'default'} />
        },
        {
            field: 'actions', headerName: 'Ações', width: 80, sortable: false,
            renderCell: (params) => (
                <RowAction title="Detalhes" onClick={() => props.onDetail(params.row)}>
                    <DescriptionIcon fontSize="small" />
                </RowAction>
            )
        }
    ];

    return (
        <DataGrid
            {...dataGridDefaults}
            rows={props.rows}
            columns={columns}
            loading={props.loading}
            rowCount={props.rowCount}
            paginationMode="server"
            paginationModel={{ page: props.page, pageSize: props.pageSize }}
            onPaginationModelChange={(model) => props.onPaginationChange(model.page, model.pageSize)}
            rowHeight={60}
        />
    );
}
